import { render } from "./ModalComboDoComboGom.vue?vue&type=template&id=1625e2bc&scoped=true"
import script from "./ModalComboDoComboGom.vue?vue&type=script&lang=js"
export * from "./ModalComboDoComboGom.vue?vue&type=script&lang=js"

import "./ModalComboDoComboGom.vue?vue&type=style&index=0&id=1625e2bc&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1625e2bc"]])

export default __exports__